import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ValidatedWholeNumberTextInput } from '__components/Inputs/TextInput/presets/WholeNumber';
import { useFlashTransition } from '__hooks/useFlashState';

export const MaxConcurrentExecutionsInput: FC<{
  value: number;
  error?: string;
  onChange: (value: number) => void;
  onBlur: () => void;
  disabled: boolean;
}> = ({ value, onChange, error, onBlur, disabled }) => {
  const { t } = useTranslation();
  const [, showErrorMessage, flashError, cancelFlash] = useFlashTransition();

  useEffect(() => {
    if (error) {
      flashError(error);
    }
  }, [error, flashError]);

  const handleChange = (v: number) => {
    onChange(v);
    cancelFlash();
  };
  return (
    <ValidatedWholeNumberTextInput
      value={value}
      onChange={handleChange}
      validate={{
        message: error,
        showMessage: showErrorMessage,
      }}
      error={error}
      onBlur={onBlur}
      disabled={disabled}
      label={t('Max Concurrent Executions')}
      labelInfo={t(
        'Raising this value above 1 is not recommended for most Smart Connectors, and is usually not compatible with the "Only Process Rows that Contain New Data" setting'
      )}
      labelInfoPlacement="top"
    />
  );
};
